import ObjectShowcase from './ObjectShowcase'
import MapRoute from './MapRoute'
import FlowDiagram from './FlowDiagram'
import DataViz from './DataViz'
import TextReveal from './TextReveal'
import Timeline from './Timeline'
import ComparisonScene from './ComparisonScene'
import ConceptIllustration from './ConceptIllustration'
import CodeBlock from './CodeBlock'
import QuoteHighlight from './QuoteHighlight'
import StatGrid from './StatGrid'
import ListReveal from './ListReveal'
import ZoomText from './ZoomText'

export const SCENE_REGISTRY = {
  ObjectShowcase,
  MapRoute,
  FlowDiagram,
  DataViz,
  TextReveal,
  Timeline,
  ComparisonScene,
  ConceptIllustration,
  CodeBlock,
  QuoteHighlight,
  StatGrid,
  ListReveal,
  ZoomText,
}

export function getSceneComponent(sceneType) {
  return SCENE_REGISTRY[sceneType] || null
}

export const VALID_SCENE_TYPES = Object.keys(SCENE_REGISTRY)
